import {
  AlertOctagon,
  Bell,
  ClipboardCheck,
  CreditCard,
  Gift,
  Layout,
  MessageCircle,
  MessageSquarePlus,
  TrendingDown,
  TrendingUp,
  UserMinus,
  UserPlus,
  type LucideIcon,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  notificationMeta,
  severityIconClass,
  type NotificationIconName,
} from '@/lib/notifications'
import type { NotificationSeverity } from '@/lib/api/admin-notifications'

/** Resolves the icon names produced by the (React-free) notifications helper. */
const ICONS: Record<NotificationIconName, LucideIcon> = {
  'credit-card': CreditCard,
  'alert-octagon': AlertOctagon,
  gift: Gift,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'message-circle': MessageCircle,
  'message-square-plus': MessageSquarePlus,
  'clipboard-check': ClipboardCheck,
  'user-plus': UserPlus,
  'user-minus': UserMinus,
  layout: Layout,
  bell: Bell,
}

interface NotificationIconProps {
  type: string
  severity: NotificationSeverity
  className?: string
}

export function NotificationIcon({ type, severity, className }: NotificationIconProps) {
  const Icon = ICONS[notificationMeta(type).icon]
  return <Icon className={cn('h-4 w-4 shrink-0', severityIconClass(severity), className)} />
}
